














import AlbumItem from './albumItem.vue'
import { pxToVW, toItem } from '../../../helper'
import { Component, Vue, Prop } from 'vue-property-decorator'
@Component({
  components: { AlbumItem }
})

export default class AlbumList extends Vue {
  @Prop() albums: any
  get getScollerWidth() {
    return { width: pxToVW(this.albums.length * 228) }
  }
  albumClick(options) {
    return toItem(options)
  }
}
